import { css } from '@emotion/react';
import type * as React from 'react';

const actionsRowStyle = css`
	display: flex;
	gap: 0.625rem;
	flex-wrap: wrap;
`;

type Props = {
	readonly children: React.ReactNode;
};

/** The row of buttons drawn in a dossier's identity banner. */
const SubjectActionsRow: React.FC<Props> = ({ children }) => {
	return <div css={actionsRowStyle}>{children}</div>;
};

export default SubjectActionsRow;
